// Output-mapper registry keys for the Orderwise integration owner (one per document type).
export const ORDERWISE_OUTPUT_MAPPER_KEYS = {
    order: 'orderwise.order',
    rfq: 'orderwise.rfq',
} as const;
